module.exports = __webpack_public_path__ + "img/阀门.ff3c24ad.jpg";